"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.tags.placeholder': '输入用逗号分隔的标签',
    'knowledge.tags.help': '按回车键添加每个标签',
};
